import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { GfTranslateService } from '../../../core/services/core.translate.service';

import * as _ from 'lodash';

@Component({
    selector: 'frs-progress-bar',
    template: `<div class="progress"
    title="{{labelText}}">
    <div class="progress-bar {{barStyle}}"
         role="progressbar"
         [attr.aria-valuenow]="releasePercent"
         aria-valuemin="0"
         aria-valuemax="100"
         [ngStyle]="{ width: releasePercent + '%' }"
         style="margin-right: 1em;">
        <div class="flood-section text-right truncate-text">
            <span ng-if="releasePercent >= 50">{{labelText}}</span>
        </div>
    </div>
    <div class="flood-section text-left truncate-text"
        style="display: inline-block;">
        <span ng-if="releasePercent < 50">{{labelText}}</span>
    </div>
</div>`
})
export class FrsProgressBarComponent implements OnChanges {

    @Input() release: any = null;

    private total = 0;
    private closed = 0;
    private remaining = 0;
    protected releasePercent = 0;
    protected barStyle = '';
    protected labelText = '';

    constructor(
        private gfTranslateService: GfTranslateService, 
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        this.total = _.get(this, 'release.rel.tisummary.tracker_items_count', 0);
        this.closed = _.get(this, 'release.rel.tisummary.closed_tracker_items_count', 0);
        this.remaining = this.total - this.closed;
        this.releasePercent = this.getReleaseProgress();
        this.barStyle = this.getBarStyle();

        var rem = this.gfTranslateService.translate('Remaining');
        this.labelText = `${this.releasePercent}% (${this.closed}/${this.total}) - ${this.remaining}   ${rem}`;
    };

    getReleaseProgress() {
        if (this.closed == 0) {
            return 0;
        }
        return Math.round((this.closed / this.total) * 100);
    };

    getBarStyle() {
        if (this.releasePercent > 75) return 'progress-bar-success';
        if (this.releasePercent > 50) return 'progress-bar-warning';
        return 'progress-bar-danger'
    };
};